import './InlineInputForm.scss';
import classNames from 'classnames';
import { haltClickEventPropagation } from '@lib/events';
import { OutsideClickWrapper } from '@ui/general';
import { Button, Form, Input, Space } from 'antd';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
const baseRules = [
    {
        required: true
    }
];
export const InlineInputForm = ({ cancelProps, className, confirmProps, currentValue, inputProps, maxLength, noPadding, onCancel, onSubmit, processing, wrapperProps }) => {
    const [value, setValue] = useState(currentValue);
    const [form] = Form.useForm();
    const rules = maxLength ? [...baseRules, { max: maxLength }] : baseRules;
    return (React.createElement(OutsideClickWrapper, Object.assign({ onClick: haltClickEventPropagation, onClickOutside: onCancel }, wrapperProps),
        React.createElement(Form, { className: classNames('inline-input-form', { 'no-padding': noPadding }, className), form: form, layout: 'inline', onFinish: (values) => { var _a; return onSubmit((_a = values.value) === null || _a === void 0 ? void 0 : _a.trim()); } },
            React.createElement(Space, { size: 2 },
                React.createElement(Form.Item, { initialValue: currentValue, name: 'value', noStyle: true, rules: rules },
                    React.createElement(Input, Object.assign({ id: currentValue ? 'edit-input' : 'create-input' }, inputProps, { autoFocus: true, maxLength: maxLength, onChange: (e) => setValue(e.target.value), onPressEnter: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            form.submit();
                        } }))),
                React.createElement(Button, Object.assign({ id: currentValue ? 'edit-confirm' : 'create-confirm' }, confirmProps, { disabled: !value, htmlType: 'submit', icon: React.createElement(PlusOutlined, null), loading: processing, type: 'primary' })),
                React.createElement(Button, Object.assign({ id: currentValue ? 'edit-view-cancel' : 'create-view-cancel' }, cancelProps, { danger: true, disabled: processing, ghost: true, htmlType: 'reset', icon: React.createElement(CloseOutlined, null), onClick: onCancel }))))));
};
